<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-09-08 10:46:28
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2025-02-14 15:10:11
 * @FilePath: /wemeet-admin-new/src/views/marketing/components/addPoints.vue
 * @Description:
 * Copyright (c) 2023 by WeMeet, All Rights Reserved.
-->
<template>
  <el-drawer
    ref="drawerRef"
    v-model="dialogFormVisible"
    :before-close="handleClose"
    custom-class="demo-drawer userInfoDrawer"
    :direction="direction"
    :size="size"
    :title="title"
  >
    <el-form ref="reasonRef" :label-position="labelPosition" :label-width="150" :model="form" :rules="rules">
      <el-form-item label="任务名称" prop="taskName">
        <el-input v-model="form.taskName" maxlength="100" type="text" />
      </el-form-item>
      <el-form-item v-if="title != '编辑'" label="活动类型" prop="taskTypeCode">
        <el-select v-model="form.taskTypeCode">
          <el-option v-for="item in typeList" :key="item.code" :label="item.typeName" :value="item.code" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="title != '编辑'" label="积分规则" prop="ruleKey">
        <el-select v-model="form.ruleKey">
          <el-option
            v-for="item in [
              {
                value: 'DIRECT_ACCESS',
                label: '扫码直接获取积分(每日一次)',
              },
              {
                value: 'NEED_TWICE_SCAN',
                label: '同一个码扫码两次获得积分(两次需间隔20分钟)',
              },
              {
                value: 'ALLOW_REPEAT_SCAN',
                label: '扫码直接获取积分(不限制次数)',
              },
            ]"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="form.remark" maxlength="100" type="text" />
      </el-form-item>
      <el-form-item label="扫码获取积分数量" prop="points">
        <el-input-number v-model="form.points" :min="0" />
      </el-form-item>
      <el-form-item v-if="title != '编辑'" label="可获取积分总人数" prop="totalQuota">
        <el-input-number v-model="form.totalQuota" :min="0" />
      </el-form-item>
      <el-form-item align="center">
        <el-button size="large" type="primary" @click="submit">提交</el-button>
      </el-form-item>
    </el-form>
  </el-drawer>
</template>
<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, ref, toRefs } from 'vue'
  import { addActivity, updateActivity, getActivityTypeList } from '@/api/exhibitionManage'
  import wmtImage from '@/components/wmt-image'
  import VueCropper from '@/extra/VueCropper'
  export default defineComponent({
    name: 'SendMessage',
    components: {
      wmtImage,
      VueCropper,
    },
    props: {
      meetingCode: {
        type: String,
        default: '',
      },
      meetingType: {
        type: String,
        default: 'EXHIBITION',
      },
    },
    setup(props, { emit }) {
      const { proxy } = getCurrentInstance()
      const state = reactive({
        imgUrl: '',
        brandLogoOption: {
          outputSize: 1, // 裁剪生成图片的质量
          outputType: 'jpeg', // 裁剪生成图片的格式 jpeg, png, webp
          info: true, // 裁剪框的大小信息
          canScale: true, // 图片是否允许滚轮缩放
          autoCrop: true, // 是否默认生成截图框
          autoCropWidth: 280, // 默认生成截图框宽度
          autoCropHeight: 280, // 默认生成截图框高度
          fixedBox: true, // 固定截图框大小 不允许改变
          fixed: false, // 是否开启截图框宽高固定比例，这个如果设置为true，截图框会是固定比例缩放的，如果设置为false，则截图框的狂宽高比例就不固定了
          fixedNumber: [1, 1], // 截图框的宽高比例 [ 宽度 , 高度 ]
          canMove: true, // 上传图片是否可以移动
          canMoveBox: true, // 截图框能否拖动
          original: false, // 上传图片按照原始比例渲染
          centerBox: true, // 截图框是否被限制在图片里面
          infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
          full: true, // 是否输出原图比例的截图
          enlarge: '1', // 图片根据截图框输出比例倍数
          mode: 'contain', // 图片默认渲染方式 contain , cover, 100px, 100% auto
        },
        dialogFormVisible: false,
        direction: 'rtl',
        size: '30%',
        detail: {
          attentFormDtoList: [],
        },
        title: '添加奖品',
        rules: {
          taskName: [{ required: true, message: '请填写任务名称', trigger: 'blur' }],
          taskTypeCode: [{ required: true, message: '请选择活动类型', trigger: 'change' }],
          ruleKey: [{ required: true, message: '请选择积分规则', trigger: 'change' }],
          // points: [
          //   { required: true, message: '请填写中奖概率', trigger: 'blur' },
          // ],
          // totalQuota: [{ required: true, message: '请填写库存', trigger: 'blur' }],
        },

        form: {
          reason: '',
          imgUrl: '',
          points: 0,
          totalQuota: 0,
        },
        reasonRef: null,
        row: null,
        labelPosition: 'left',
        vabCropperRef: null,
        typeList: [],
      })
      // 打开
      const handleOpen = async (row) => {
        if (row) {
          state.form = Object.assign(state.form, row)
          state.title = '编辑'
          state.imgUrl = row.imgUrl
        } else {
          state.title = '添加'
        }
        state.dialogFormVisible = true
        getActivityTypeList({
          meetingCode: props.meetingCode,
          pageSize: 999,
          pageNum: 1,
        }).then((res) => {
          state.typeList = res.data.list
        })
      }
      // 关闭
      const handleClose = () => {
        state.form = {
          dailyLimit: 0,
          probability: 0,
          points: 0,
          taskName: '',
          totalQuota: 0,
          taskTypeCode: '',
          ruleKey: '',
          remark: '',
        }
        state.imgUrl = ''
        state['reasonRef'].resetFields()
        state.dialogFormVisible = false
      }

      const submit = async () => {
        state['reasonRef'].validate(async (valid) => {
          if (valid) {
            try {
              state.form.meetingCode = props.meetingCode
              if (state.form.taskCode) {
                const { data } = await updateActivity(state.form)
              } else {
                const { data } = await addActivity(state.form)
              }
              proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
              emit('fetch-data')
              handleClose()
            } catch (err) {
              console.log(err)
            }
          }
        })
      }

      const upLoadLogo = () => {
        state['vabCropperRef'].dialogVisible = true
      }

      const deleteImg = () => {
        state.imgUrl = ''
      }

      const logoInfo = (coverUrl) => {
        console.log('coverUrl', coverUrl)
        state.imgUrl = coverUrl
      }

      return {
        ...toRefs(state),
        handleOpen,
        handleClose,
        submit,
        upLoadLogo,
        deleteImg,
        logoInfo,
      }
    },
  })
</script>

<style lang="scss">
  .userInfoDrawer {
    .el-transfer-panel {
      width: 250px;
    }

    .hideLabel {
      .el-descriptions__label {
        display: none;
      }
    }
  }
</style>

<style lang="scss" scoped>
  .vab-tree-border {
    height: 200px;
    padding: $base-padding;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: $base-border-radius;
  }

  .demo-drawer__content {
    height: 85vh;
    overflow: auto;
  }

  .containerForm {
    height: 85vh;
    overflow-y: auto;
  }

  .demo-drawer__footer {
    position: fixed;
    right: 20px;
    bottom: 10px;
  }

  .margin-top {
    margin-top: 20px;
  }

  .basicMessage {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    line-height: 50px;

    .desc {
      margin: 0 10px;
    }
  }
</style>
